<div class="mb-3">
  @if (control().hasLabel) {
    <mat-label [style.color]="control().labelColour">{{ control().label }}</mat-label>
  }
  @if (isHorizontal) {
    <!-- Codes only, as one wrapping run — the same output the PDF renderer produces for this layout. -->
    <div class="diagnosis-code-list" [style.color]="control().valueColour">{{ codeList }}</div>
  } @else {
  <mat-list class="mat-list-dynamic">
    @for (item of diagnosisList(); track ($index + item.id + item.icD10Code); let i = $index) {
      <mat-list-item [style.color]="control().valueColour">
        @if (item.comment) {
          <span matListItemLine>{{ i + 1 }} - {{ describe(item) }}</span>
        }
        @if (!item.comment) {
          <span>{{ i + 1 }} - {{ describe(item) }}</span>
        }
        @if (item.comment) {
          <span matListItemLine>{{ item.comment }}</span>
        }
      </mat-list-item>
    }
  </mat-list>
  }
</div>
